import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Button from './button';
import { utils } from '../utils/common';
import { appLocalStore } from '../stores/appLocalStore';
import { observer } from 'mobx-react-lite';

interface QrCodeModalProps {
  url: string;
  onClose: () => void;
}


// TODO - Reconsider the current usage of the onClose
const QrCodeModal: React.FC<QrCodeModalProps> = observer(({ url, onClose }) => {
  
  const qrCodeModalState = appLocalStore.modals.qrCodeModal;
  
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/80 flex justify-center items-center z-[1000]" onClick={onClose}>
      <div className="bg-[var(--bg-primary)] rounded-2xl p-8 max-w-md w-[90%] shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-[var(--text-primary)] text-2xl font-bold m-0 mb-2 text-center">Scan to Join</h2>
        <p className="text-[var(--text-secondary)] text-sm m-0 mb-6 text-center">Scan this QR code to join the game</p>
        
        <div className="flex justify-center items-center bg-white rounded-xl p-4 mb-6">
          <QRCodeSVG 
            value={url} 
            size={256}
            level="M"
            includeMargin={true}
          />
        </div>
        
        <div className="flex flex-col gap-3">
          <Button onClick={() => utils.copyToClipboardAnimatedAsync(url, (value) => appLocalStore.modals.qrCodeModal.action(_ => _.copied = value))} fullWidth variant={qrCodeModalState.copied ? 'secondary' : 'primary'}>
            {qrCodeModalState.copied ? '✓ Copied!' : 'Copy Link'}
          </Button>
          <Button onClick={onClose} fullWidth variant="secondary">
            Close
          </Button>
        </div>
      </div>
    </div>
  );
});

export default QrCodeModal;
